module.exports = __webpack_public_path__ + "static/media/phone.09fa4bfc.svg";